var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicoLogoRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 532 316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 5px;\n      }\n\n      .cls-2 {\n        fill: #e11f1d;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 268.3,
    cy: 158.1,
    rx: 259.6,
    ry: 153.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 268.3,
    cy: 158.1,
    rx: 250.9,
    ry: 146
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.1,139l3.8-30.9s-20-9.5-51.2-6.5c-31.1,3-49.6,16-58,44.8,0,0-7.1,36.6,19.5,55.7,0,0,21.3,18,65.7,13.7,0,0,14.7-1.4,24.4-4.3l-2.6-32.1s-38.6,16.4-56.7.1-8.9-31.7-5.1-38.1c3.8-6.4,15.3-13.1,34.5-11.2,0,0,15.3,1.1,25.8,8.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M478.7,128.2c-16.7-29.9-55.1-26.6-55.1-26.6-42.5,0-53.1,24.7-53.1,24.7-19.2,33.1-.8,64-.8,64,16.5,27.9,55.8,25.2,55.8,25.2,41.7,1.6,55-29.8,55-29.8,14.5-31.7-1.8-57.5-1.8-57.5h0ZM426.2,194.1s-30.6,3.5-30.7-37.4c0,0-.6-32.6,28.8-33.7,0,0,25.6-2,28,32.5,0,0,4.1,33.9-26.2,38.6h.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "182 103 222.7 103 222.7 214.7 182.4 214.7 182 103"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "66.7 102.5 166.2 102.5 166.2 132.3 136.8 132.3 136.8 215.1 95.9 215.1 95.9 132.5 66.6 132.5 66.7 102.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M498.4,261.9c11,0,19.8,9,19.8,19.9s-9,19.9-19.9,19.8c-10.9,0-19.8-9-19.8-19.9s9-19.8,19.9-19.8h0ZM498.3,299.1c9.6,0,17.4-7.8,17.4-17.4s-7.8-17.3-17.5-17.3-17.2,7.9-17.2,17.4,7.8,17.4,17.4,17.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M502.3,283.3c1.6,2.9,3.1,5.8,4.8,8.8h-3.8c-.2,0-.3-.3-.4-.5-1.2-2.4-2.5-4.7-3.7-7.1-.2-.4-.4-.5-.8-.5h-3.5v8h-3.6v-20.8h8.4c1.9,0,3.7.6,5,2.1,2.5,2.8,1.7,7.6-1.6,9.4-.2.1-.5.3-.8.4h0v.2ZM494.9,274.3v6.9h4.8c1.8-.4,2.8-1.6,2.8-3.4s-1-3.1-2.9-3.4c-1.5-.2-3.1,0-4.7,0h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicoLogoRegistered);
export default __webpack_public_path__ + "static/media/Tico-Logo_registered.82489a5881ac86dd6dd43907f9896eca.svg";
export { ForwardRef as ReactComponent };